export default {
    verify(that) {
        let flag = true
        let message = ""
        if (!that.addForm.submit) {
            return { flag, message }
        }
        if (that.addForm.workflow == 0) {
            if (!that.sf) {
                message = "始发地不能为空";
                flag = false;
            }
            if (!that.md) {
                message = "目的地不能为空";
                flag = false;
            }
            if (!that.addForm.leaveTime) {
                message = "开始日期不能为空";
                flag = false;
            }
            if (!that.addForm.returnTime) {
                message = "结束日期不能为空";
                flag = false;
            }
            if (!that.addForm.travelTypeName) {
                message = "出差类型不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                // if (!item.department) {
                //     message = "费用承担部门不能为空";
                //     flag = false;
                // }
                // if (!item.costName) {
                //     message = "费用类型不能为空";
                //     flag = false;
                // }
                // if (!item.beginTime) {
                //     message = "开始日期不能为空";
                //     flag = false;
                // }
                // if (!item.endTime) {
                //     message = "结束日期不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "预计金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
            });
        }
        if (that.addForm.workflow == 1) {
            if (!that.sf) {
                message = "始发地不能为空";
                flag = false;
            }
            if (!that.md) {
                message = "目的地不能为空";
                flag = false;
            }
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            if (!that.addForm.leaveTime) {
                message = "开始日期不能为空";
                flag = false;
            }
            if (!that.addForm.returnTime) {
                message = "结束日期不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                // if (item.invoiceType == 11 || item.invoiceType == 13) {
                //     if(!item.classLevel){
                //         message = "仓位不能为空";
                //         flag = false;
                //     }
                // }
                if (!item.costName) {
                    message = "费用类型不能为空";
                    flag = false;
                }
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
            });
        }
        if (that.addForm.workflow == 2) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.occurTime) {
                    message = "发生日期不能为空";
                    flag = false;
                }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //   message = "出行工具不能为空";
                //   flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
            });
        }
        if (that.addForm.workflow == 3) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            let applyAmount = that.addForm.detailRequestList.reduce((p, item, index) => {
                if (!isNaN(item.amount)) {
                    p = p + item.amount * 1;
                } else {
                    p = p + 0;
                }
                return p;
            }, 0);
            // if(applyAmount>2000 && !that.addForm.isHaulage && !that.addForm.isAdministrative && !that.addForm.advanceApplyNum){
            //     message = "事前申请单不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.occurTime) {
                    message = "发生日期不能为空";
                    flag = false;
                }
                // if(!item.endTime){message = "结束日期不能为空";flag=false}
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (item.taxAmount != "0") {
                    if (!item.taxAmount && String(item.costName).indexOf("补贴") == -1 && a) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
            });
        }
        if (that.addForm.workflow == 4) {
            if (!that.addForm.travelTypeName) {
                message = "出差类型不能为空";
                flag = false;
            }
            if (!that.addForm.leaveTime) {
                message = "出发日期不能为空";
                flag = false;
            }
            if (!that.addForm.returnTime) {
                message = "返回日期不能为空";
                flag = false;
            }
        }
        if (that.addForm.workflow == 5) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
                if (!item.guests) {
                    message = "招待对象不能为空";
                    flag = false;
                }
                if (!item.receptPerson) {
                    message = "招待人数不能为空";
                    flag = false;
                }
                if (!item.receptionNature) {
                    message = "招待性质不能为空";
                    flag = false;
                }

            });
        }
        if (that.addForm.workflow == 6) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
                if (!item.reimEmployeeName) {
                    message = "报销人不能为空";
                    flag = false;
                }
                if (!item.occurMonth) {
                    message = "费用发生(月份)不能为空";
                    flag = false;
                }
            });
        }
        if (that.addForm.workflow == 7) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
            });
        }
        if (that.addForm.workflow == 8) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (!item.costName) {
                    message = "费用类型不能为空";
                    flag = false;
                }
                if (!item.reimEmployeeName) {
                    message = "报销人不能为空";
                    flag = false;
                }
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
            });
        }
        if (that.addForm.workflow == 9) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            // if (that.addForm.costName.indexOf("生活用品") != -1) {
            //     if (!that.addForm.occurQuarter) {
            //         message = "发生季度不能为空";
            //         flag = false;
            //     }
            // }
            // if (that.addForm.costName.indexOf("防暑降温费") != -1) {
            //     if (!that.addForm.temperature) {
            //         message = "气温情况不能为空";
            //         flag = false;
            //     }
            // }
            // if (!that.addForm.beginDate) {
            //     message = "开始日期不能为空";
            //     if (that.addForm.costName.indexOf("误餐费") != -1) {
            //         message = "发生日期不能为空"
            //     }
            //     flag = false;
            // }
            // if (that.addForm.costName.indexOf("误餐费") == -1) {
            //     if (!that.addForm.endDate) {
            //         message = "结束日期不能为空";
            //         flag = false;
            //     }
            // }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
                // if (that.addForm.costName.indexOf("误餐费") != -1) {
                //     if (!item.diningNumber) {
                //         message = "用餐顿数不能为空";
                //         flag = false;
                //     }
                //     // if (!item.beginDate) {
                //     //     message = "发生日期不能为空";
                //     //     flag = false;
                //     // }
                //     if (!item.leaveTime) {
                //         message = "开始时间不能为空";
                //         flag = false;
                //     }
                //     if (!item.backTime) {
                //         message = "结束时间不能为空";
                //         flag = false;
                //     }

                // }
                //   if (!item.count) {
                //     message = "数量不能为空";
                //     flag = false;
                //   }
                // if (!item.price) {
                //     message = "单价不能为空";
                //     flag = false;
                // }
            });
        }

        if (that.addForm.workflow == 10) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.budgetUnit) {
                message = "预算单位不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }

                if (!item.beginDate) {
                    message = "开始时间不能为空"
                    flag = false
                }
                if (!item.endDate) {
                    message = "结束时间不能为空"
                    flag = false
                }
                // if (item.meetingType != 0 && !item.meetingType) {
                //     message = "会务类型不能为空"
                //     flag = false
                // }
                if (!item.meetingPlace) {
                    message = "会议地点不能为空"
                    flag = false
                }
                if (item.attendance != 0 && !item.attendance) {
                    message = "人数不能为空"
                    flag = false
                }

            });
        }
        if (that.addForm.workflow == 11) {
            if (!that.addForm.leaveTime) {
                message = "开始时间不能为空"
                flag = false
            }
            if (!that.addForm.returnTime) {
                message = "结束时间不能为空"
                flag = false
            }
            if (that.addForm.number != 0 && !that.addForm.number) {
                message = "人数不能为空"
                flag = false
            }
            if (!that.addForm.city) {
                message = "城市不能为空"
                flag = false
            }
            if (that.addForm.price != 0 && !that.addForm.price) {
                message = "单价不能为空"
                flag = false
            }
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.budgetUnit) {
                message = "预算单位不能为空";
                flag = false;
            }
            if (that.addForm.haveInvoice !== 0 && that.addForm.haveInvoice !== 1) {
                message = "是否无票不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (!that.addForm.haveInvoice) {
                    if (
                        !item.invoiceNumber &&
                        String(item.costName).indexOf("补贴") == -1
                    ) {
                        message = "发票号码不能为空";
                        flag = false;
                    }
                    if (
                        !item.invoiceTypeName &&
                        String(item.costName).indexOf("补贴") == -1
                    ) {
                        message = "发票类型不能为空";
                        flag = false;
                    }
                    // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                    //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                    //     message = "发票代码不能为空";
                    //     flag = false;
                    // }
                    if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                        message = "不含税金额不能为空";
                        flag = false;
                    }
                    if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                        message = "税率不能为空";
                        flag = false;
                    }
                    if (
                        item.taxAmount != "0" &&
                        String(item.costName).indexOf("补贴") == -1 && a
                    ) {
                        if (!item.taxAmount) {
                            message = "税额不能为空";
                            flag = false;
                        }
                    }
                    if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                        message = "价税合计不能为空";
                        flag = false;
                    }
                }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                
            });
        }
        if (that.addForm.workflow == 12) {
            // if (!that.addForm.expenseDepartName) {
            //     message = "费用承担部门不能为空";
            //     flag = false;
            // }
            if (!that.addForm.costName) {
                message = "费用类型不能为空";
                flag = false;
            }
            if (!that.addForm.budgetUnit) {
                message = "预算单位不能为空";
                flag = false;
            }
            if (!that.addForm.paywayName) {
                message = "支付方式不能为空";
                flag = false;
            }
            that.addForm.detailRequestList.forEach((item) => {
                let arr = [1, 2, 3, 5, 9, 13, 19, 20, 21];
                let a = arr.indexOf(Number(item.invoiceType)) != -1;
                let arr2 = [5, 9, 13, 19]
                let b = arr2.indexOf(Number(item.invoiceType)) != -1;
                if (
                    !item.invoiceNumber &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票号码不能为空";
                    flag = false;
                }
                // if (!item.goodsName && String(item.costName).indexOf("补贴") == -1) {
                //     message = "发票服务名称不能为空";
                //     flag = false;
                // }
                if (!item.amount) {
                    message = "报销金额不能为空";
                    flag = false;
                }
                // if (!item.travelToolName) {
                //     message = "出行工具不能为空";
                //     flag = false;
                // }
                if (
                    !item.invoiceTypeName &&
                    String(item.costName).indexOf("补贴") == -1
                ) {
                    message = "发票类型不能为空";
                    flag = false;
                }
                // if (!item.invoiceCode && String(item.costName).indexOf("补贴") == -1 &&
                //     String(item.invoiceTypeName).indexOf("增值税") != -1) {
                //     message = "发票代码不能为空";
                //     flag = false;
                // }
                if (!item.noTaxAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "不含税金额不能为空";
                    flag = false;
                }
                if (!item.taxRate && String(item.costName).indexOf("补贴") == -1 && a) {
                    message = "税率不能为空";
                    flag = false;
                }
                if (
                    item.taxAmount != "0" &&
                    String(item.costName).indexOf("补贴") == -1 && a
                ) {
                    if (!item.taxAmount) {
                        message = "税额不能为空";
                        flag = false;
                    }
                }
                if (!item.totalAmount && String(item.costName).indexOf("补贴") == -1) {
                    message = "价税合计不能为空";
                    flag = false;
                }
            });
        }



        return { flag, message }
    },
}